// extracted by mini-css-extract-plugin
module.exports = {"Message":"Message__Message__38cku"};